<!--
 * @Author: your name
 * @Date: 2021-06-26 16:38:14
 * @LastEditTime: 2026-07-25 13:46:53
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\ToolsList\ToolWeather.vue
-->
<!--天气-->

<template>
  <div class="tool-weather" :class="{'multi-line':!media.ext_val_isSingleLine}" :style="eleStyle">
    <span v-show="media.ext_val_bPlaceShow">{{weather.city}}:{{weather.sky}}</span>
    <span v-show="media.ext_val_wenduShow">{{$t('PE.Temp')}}:{{weather.heat}}</span>
    <span v-show="media.ext_val_bWindShow">{{$t('PE.WindPower')}}:{{weather.windScale}}</span>
    <span v-show="media.ext_val_bHumidityShow">{{$t('PE.Humidity')}}:{{weather.humidity}}</span>
    <div class="text-val" v-show="media.ext_val_bWearShow">{{$t('PE.DressingIndex')}}:{{weather.proposed}}</div>
  </div>
</template>

<script>
export default {
  name: "ToolWeather",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      weather: {
        city: "",
        sky: "",
        heat: "",
        windScale: "",
        humidity: "",
        proposed: ""
      }
    }
  },
  methods: {
    getWeather(citykey) {
      // fetch(`http://wthrcdn.etouch.cn/WeatherApi?citykey=${citykey}`, {
      //   method: 'get'
      // }).then(response => {
      //   return response.text();
      // }).then(res => {
      //   let weather = this.$x2js.xml2js(res);
      //   // console.log(weather);
      //   this.weather = {
      //     city: weather.resp.city,
      //     sky: weather.resp.forecast.weather[0].day.type,
      //     heat: weather.resp.wendu,
      //     windScale: weather.resp.fengxiang + weather.resp.fengli,
      //     humidity: weather.resp.shidu,
      //     proposed: weather.resp.zhishus.zhishu[0].detail
      //   };
      //   this.media.ext_val_city = this.weather.city
      // });

      fetch(`https://admin.kystarcloud.com/weather/getWeather?citykey=${citykey}`, {
        method: 'get'
      }).then(response => response.json()).then(res => {
        console.log(this.media.ext_val_city);
        const { dayType, wendu, fengli, shidu, indices } = res.data;
        this.weather = {
          city: this.media.ext_val_city,
          sky: dayType,
          heat: wendu + "°C",
          windScale: fengli,
          humidity: shidu,
          proposed: indices[2].text
        };
        this.media.ext_val_city = this.weather.city
      });
    },
    // 天气获取二
    // getWeatherMini(citykey) {
    //   fetch(`http://wthrcdn.etouch.cn/weather_mini?citykey=${citykey}`, {
    //     method: 'get'
    //   }).then(response => response.json()).then(weather => {
    //     console.log(weather);
    //   });
    // }
  },
  computed: {
    eleStyle() {
      return {
        'font-size': this.media.ext_val_textSize * 1 * this.ratio + 'px',
        'font-family': this.media.ext_val_family,
        'background': this.media.ext_val_backgroundColor,
        'color': this.media.ext_val_textColor
      }
    },
    ratio() {
      return this.$store.state.program.ratio;
    }
  },
  watch: {
    'media.ext_val_cityCode': {
      handler(nVal) {
        this.getWeather(nVal);
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.tool-weather {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: left;
  justify-content: center;
  user-select: none;
  overflow: hidden;
  .text-val {
    width: 100%;
    word-wrap: break-word;
    word-break: normal;
  }
}
.multi-line {
  flex-direction: column;
}
</style>